// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js?minimize!../../../vue-loader/lib/style-rewriter.js?id=data-v-0ee9ce4c!../../../vue-loader/lib/selector.js?type=styles&index=0!./TableFooter.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("47bc4e1a", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0ee9ce4c!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/Table/TableFooter.vue
// module id = 1377
// module chunks = 2